import React from 'react';
import { skillGroups } from './ResumeData';

export function Skills() {
  return (
    <main className="Skills">
      <h2>Technical Skills</h2>
      <table className="table table-striped">
        <thead><tr><th>Category</th><th>Skills</th></tr></thead>
        <tbody>{Object.entries(skillGroups).map(([category, skills]) => (
          <tr key={category}><td><strong>{category}</strong></td><td>{skills.join(', ')}</td></tr>
        ))}</tbody>
      </table>
    </main>
  );
}
